<template>
    <vue-select :multiple="isMultiple"
                :searchable="searchable"
                :id="id"
                :value="value"
                :options="options.values"
                @input="handleInput"
                @search:focus="handleFocus($event)"
                @search:blur="handleBlur"
    ></vue-select>
</template>

<script>
    import vueSelect from 'vue-select'
    export default {
        name: 'select-field',
        components: {vueSelect},
        props: {
            id: String,
            value: [String,Array],
            options: {
                type: Object,
                default: () => {return {}}
            },
            searchable: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            handleInput(e) {
                this.$emit('input', e);
            },
            handleFocus() {
                this.$emit('focus', true)
            },
            handleBlur() {
                this.$emit('blur', false)
            }

        },
        computed: {
            isMultiple() {
                if (this.options) {
                    return !!this.options.multiple
                }
                return false
            }
        },
        created() {
            if(!this.value && this.options.values[0] ) {
                this.$emit('input', this.options.values[0]);
            }

        }
    }
</script>


<style scoped>

</style>
